<script>
  import models from './../stores/models';
	import colorsModelsMap, { getNewColorsMap } from './../stores/colorsModelsMap';
  import TrashIcon from "./icons/TrashIcon.svelte";
  import { updateCompareUrl } from './../utils';

  export let src = '';
  export let specId;

  const handleModelDelete = (id) => {
    models.update(currentModels => {
      return currentModels.filter(model => model.id != id);
    });
    colorsModelsMap.update(() => {
      return getNewColorsMap($models);
    });
    updateCompareUrl($models);
  }
</script>

<div on:click={() => handleModelDelete(specId)} class="specs-modal__image-wrapper">
  <img class="rounded specs-modal__img" src={src} alt="">
  <div class="trash-icon">
    <TrashIcon />
  </div>
</div>

<style lang="scss">
  .specs-modal__img {
    width: 100%;
		margin-right: 10px;
    transition: all .15s ease-in-out;
	}

  .specs-modal__image-wrapper {
    position: relative;
  }

  .specs-modal__image-wrapper:hover img {
    cursor: pointer;
    opacity: 0.4;
  }

  .specs-modal__image-wrapper:hover .trash-icon {
    opacity: 1;
    transition: all .15s ease-in-out;
  }

  .trash-icon {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>